import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent {
  @Input()
  public link: string
  @Input()
  public isActive: boolean
  @Input()
  public isDone: boolean
  @Input()
  public i18nKey: string
  @Input()
  public wasAlreadyVisited: boolean
}
